var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAws(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F6A81C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.6,589.6l-75.9,32.6l70.3,30l81.5-30L327.6,589.6L327.6,589.6z M213.5,630.3L211,777l111,48.9V673.6 L213.5,630.3L213.5,630.3z M441.6,630.3l-100.3,38.2v143.6l100.3-40.7V630.3L441.6,630.3z M561.3,174.2l-76.4,32.6l70.8,30l81.5-30 L561.3,174.2L561.3,174.2z M455.4,217.4v146.6l94.7,27.5l3.1-133.4L455.4,217.4L455.4,217.4z M667.2,225.6l-89.6,38.2v144.1 l89.6-40.7L667.2,225.6L667.2,225.6z M202.6,380.5l-75.9,32.6l70.3,30l81.5-30L202.6,380.5L202.6,380.5z M88.5,421.3L86,567.9 l111,48.9V464.5L88.5,421.3z M316.6,421.3l-100.3,38.2V603l100.3-40.7V421.3z M447,375.1l-75.9,32.6l70.3,30l81.5-30L447,375.1 L447,375.1z M332.9,415.9l-2.5,146.6l111,48.9V459.1L332.9,415.9z M561,415.9L460.7,454v143.6L561,556.9V415.9L561,415.9z  M800,174.2l-75.9,32.6l70.3,30l81.5-30L800,174.2L800,174.2z M685.9,214.9l-2.5,146.6l111,48.9V258.2 C794.4,258.2,685.9,214.9,685.9,214.9z M914,214.9l-100.3,38.2v143.6L914,355.9C914,355.9,914,214.9,914,214.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.73d5c23061e4d5d4ed0feaffb9aeb5d4.svg";
export { ForwardRef as ReactComponent };